import React, { useState, useEffect } from 'react';
import { Bed, Bath, MapPin, Home } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const PropertyListAdminHorizontal = ({ properties = [], openModal, currency }) => {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [visibleCount, setVisibleCount] = useState(8); // ✅ เริ่มแสดง 8 ทรัพย์

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const formatPrice = (price) => {
    if (!price) return '-';
    const exchangeRate = 36;
    const numericPrice = Number(price);
    if (isNaN(numericPrice)) return price;

    return currency === 'THB'
      ? `${numericPrice.toLocaleString()} THB`
      : `${(numericPrice / exchangeRate).toFixed(2)} USD`;
  };

  // ✅ แสดงเฉพาะตามจำนวนที่กำหนด
  const displayedProperties = properties.slice(0, visibleCount);

  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + 8); // ✅ เพิ่มทีละ 8
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', width: '100%' }}>
      
      {displayedProperties.map(property => (
          <div
              key={property.property_id}
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '15px',
                padding: '10px',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                backgroundColor: '#fff',
                alignItems: 'center',
                cursor:
                  property.status === 'Sold Out' || property.status === 'Rented'
                    ? 'default'
                    : 'pointer',
                position: 'relative',
                opacity:
                  property.status === 'Sold Out' || property.status === 'Rented'
                    ? 0.6
                    : 1, // จางเมื่อ Sold Out หรือ Rented
              }}
              onClick={() =>
                property.status !== 'Sold Out' && property.status !== 'Rented'
                  ? openModal(property)
                  : null
              }
            >

          {/* รูปภาพ */}
          
          {property.images && property.images[0] && (
            <div style={{ position: 'relative' }}>
              
              <img
                src={property.images[0]}
                alt={property.name}
                style={{ width: '120px', height: '90px', objectFit: 'cover', borderRadius: '8px' }}
              />
              {/* SHA ID บนรูปสำหรับ mobile */}
              {isMobile && (
                
                
                <div style={{
                  position: 'absolute',
                  top: '5px',
                  left: '5px',
                  fontSize: '12px',
                  color: '#fff',
                  backgroundColor: 'rgba(0,0,0,0.5)',
                  padding: '2px 5px',
                  borderRadius: '4px'
                }}>

                  
                  
                  {t('sha_id')}: {property.property_id}
                </div>
                
                
              )}
              
            </div>
          )}

          {/* SHA ID สำหรับ desktop */}
          {!isMobile && (
            <div style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              fontSize: '12px',
              color: '#555'
            }}>
              
              {property.featured && (
                <span style={styles.hotDealInline}>🔥 Hot Deal</span>
              )}

              {property.furnished && (
                <span style={styles.furnishedInline}>{t("Furnished_full")}</span>
              )}
              {property.status && (
                  <span
                    style={{
                      ...styles.statusInline,
                      backgroundColor:
                        property.status === "Buy"
                          ? "#F39C12" // สีส้ม
                          : property.status === "Rent"
                          ? "#3498db" // สีน้ำเงิน
                          : property.status === "Rented"
                          ? "#E74C3C" // สีม่วง
                          : property.status === "Sold Out"
                          ? "#e74c3c" // สีแดง
                          : "#95a5a6", // สีเทา default
                    }}
                  >
                    {t(property.status)}
                  </span>
                )}

              <span style={{ marginLeft: 10 }}>
                {t('sha_id')}: {property.property_id}
              </span>

            </div>
          )}

          {/* ข้อมูลทรัพย์ */}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              
              <h3 style={{ margin: 0, fontSize: '1rem', fontWeight: '600', color: '#555' }}>
                 
                {t(property.name)}
              </h3>
            </div>
            

            <div style={{ display: 'flex', gap: '10px', fontSize: '1rem', color: '#555', flexWrap: 'wrap' }}>
              <div>{formatPrice(property.price)}</div>
              
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <MapPin size={14} /> {t(property.location)}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <Home size={14} /> {t(property.type)}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <Bed size={14} /> {property.bedrooms ?? '-'}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <Bath size={14} /> {property.bathrooms ?? '-'}
                {property.status && (
                  <span
                    style={{
                      ...styles.statusInline,
                      backgroundColor:
                        property.status === "Buy"
                          ? "#F39C12" // สีส้ม
                          : property.status === "Rent"
                          ? "#3498db" // สีน้ำเงิน
                          : property.status === "Rented"
                          ? "#E74C3C" // สีม่วง
                          : property.status === "Sold Out"
                          ? "#e74c3c" // สีแดง
                          : "#95a5a6", // สีเทา default
                    }}
                  >
                    {t(property.status)}
                  </span>
                )}
              </div>
            </div>
            
          </div>
           {property.status === 'Sold Out' && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: '#f72009ff',
                    fontWeight: 'bold',
                    fontSize: '60px',
                    pointerEvents: 'none', // คลิกผ่าน overlay
                    zIndex: 5,
                  }}
                >
                  {t('Sold Out')}
                </div>
              )}
              {property.status === 'Rented' && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: '#E74C3C',
                    fontWeight: 'bold',
                    fontSize: '60px',
                    pointerEvents: 'none', // คลิกผ่าน overlay
                    zIndex: 5,
                  }}
                >
                  {t('Rented')}
                </div>
              )}
          
        </div>
      ))}
      

      {/* ✅ ปุ่มดูเพิ่มเติม */}
      {visibleCount < properties.length && (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <button
            onClick={handleLoadMore}
            style={{
              padding: '12px 25px',
              fontSize: '16px',
              fontWeight: '600',
              backgroundColor: '#dd9e2a',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'background-color 0.3s',
              fontFamily: "'Roboto Condensed', 'Kanit', sans-serif"
            }}
            onMouseOver={e => e.currentTarget.style.backgroundColor = '#c4871f'}
            onMouseOut={e => e.currentTarget.style.backgroundColor = '#dd9e2a'}
          >
            {t('See more')}
          </button>
          
        </div>
      )}
      
    </div>
  );
};
const styles = {
  hotDealInline: { background: 'linear-gradient(135deg, #ffa733, #ff6b00, #cc5200)', color: '#fff', padding: '2px 6px', borderRadius: '6px', fontSize: '11px', fontWeight: 'bold', marginLeft: '6px' },
 furnishedInline:{ background: 'linear-gradient(90deg, #1a8cff, #0a71e7)', color: '#fff', padding: '2px 6px', borderRadius: '6px', fontSize: '11px', fontWeight: 'bold', marginLeft: '6px' },
statusInline: {
    color: "#fff",
    padding: "3px 8px",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: "bold",
    marginLeft: "6px",
    textTransform: "uppercase",
  },
};

export default PropertyListAdminHorizontal;
